import { render } from "./ExamplePacks.vue?vue&type=template&id=f93d985e&scoped=true&ts=true"
import script from "./ExamplePacks.vue?vue&type=script&lang=ts"
export * from "./ExamplePacks.vue?vue&type=script&lang=ts"

import "./ExamplePacks.vue?vue&type=style&index=0&id=f93d985e&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f93d985e"]])

export default __exports__